import { FeedInterface } from 'Interfaces/FeedInterface';
import { FeedItem } from 'Interfaces/FeedItem';
import { FormInterface } from 'Interfaces/Forms/FormsInterface';
import { FEED, FORMS, PERSIST } from '../actions/actionTypes';


const cleanFeed = (current, newFeed: FeedItem[]) => {
  current = current || [];
  newFeed = newFeed || [];
  return current
    .map((feedItem) => {
      for (let i = 0; i < newFeed.length; i++) {
        if (feedItem.id === newFeed[i].id) {
          // const fi = newFeed[i];
          newFeed.splice(i, 1);
          return null;
        }
      }
      return feedItem;
    })
    .filter((f) => f !== null);
};

const INITIAL_STATE: FeedInterface = { loading: false, feed: [], filter: '', cached: false };

const setFeedFilter = (state, filter) => {
  return {
    ...state, filter
  };
};

const formsLoaded = (state: FeedInterface, forms: FormInterface[]) => {
  if (state.feed.length > 0) {
    const unique = Array.from(new Set(forms.map(f => !f.isChild ? f.ref : null)));
    const newFeed = state.feed.map(f => unique.includes(f.formid) ? f : null).filter(f => f);
    return {
      ...state,
      feed: newFeed
    };
  }
  return state;
};

const deleteFeedItem = (state: FeedInterface, pois) => {
  if (pois) {
    const deletedPois = [...pois];
    const newFeed = [...state.feed];
    let i = newFeed.length - 1;
    while (i >= 0) {
      const feedItem = newFeed[i];
      const index = deletedPois.indexOf(feedItem.id);
      if (index !== -1) {
        deletedPois.splice(index, 1);
        newFeed.splice(i, 1);
        if (deletedPois.length === 0) {
          break;
        }
      }
      i--;
    }
    return { ...state, feed: newFeed };
  }
  return state;
};

const isLoading = (state, loading) => {
  return loading && state.cached ? false : loading;
};

const feed = (state: FeedInterface = INITIAL_STATE, action) => {
  switch (action.type) {
    case FEED.LOADING:
      return { ...state, loading: isLoading(state, action.loading) };
    case FEED.LOADED:
      if (!state && action.feed) {
        return { feed: action.feed, loading: false, cached: false };
      } else if (action.feed) {
        const receivedItems = action.feed;
        const currentFeed = cleanFeed(state.feed, [...action.feed]);
        const { cached } = state;
        return {
          ...state,
          cached: false,
          feed: cached ? receivedItems.concat(currentFeed) : currentFeed.concat(receivedItems)
        };
      }
      return state;
    case FEED.USER_UPDATE:
      if (action.feed) {
        const receivedItems = action.feed;
        const currentFeed = cleanFeed(state.feed, [...action.feed]);
        return { ...state, feed: receivedItems.concat(currentFeed) };
      }
      return state;
    case FEED.CLEAR:
      return { ...state, feed: [] };
    case FEED.UPDATE:
      if (action.feedItem) {
        const feed = state.feed.filter((feedItem) => {
          if (feedItem.id === action.feedItem.id) {
            return false;
          }
          return true;
        });
        return { ...state, feed };
      }
      return state;
    case FEED.CLEAR_AUTO_UPDATE:
      if (action.feed) {
        const feedCount = state.feed.length > 0 ? state.feed[0].feedCount : 0;
        const newFeed = action.feed.filter(f => f.action === 'add');
        return { ...state, feed: action.feed.map((f: FeedItem) => (
          {...f, action: undefined, feedCount: feedCount + newFeed}
        )).concat(state.feed) };
      }
      return state;
    case FEED.DELETE:
      return deleteFeedItem(state, action.pois);
    case FEED.SET_FILTER:
      return setFeedFilter(state, action.filter);
    case FORMS.LOAD:
      return formsLoaded(state, action.payload.forms);
    case PERSIST.REHYDRATE:
      if (state.feed.length) {
        return {...state, cached: true};
      }
      return state;
    default:
      return state; //
  }
};

export default feed;
